<template>
  <div>
    <el-dialog :title="title" width="35%" :close-on-click-modal="false" :visible.sync="open" @close="setDialogClosed">
      <el-container class="container">
        <el-form :model="baseForm" :rules="rules" ref="baseFormRef" label-position="top" label-width="240px">
          <el-form-item label="科室" prop="dept">
            <el-select v-model="baseForm.dept" placeholder="请选择科室"
              @change="getMasterData('doctors', { deptId: baseForm.dept })">
              <el-option v-for="x in deptsOptions" :key="x.deptId" :label="x.name" :value="x.deptId" />
            </el-select>
          </el-form-item>
          <el-form-item label="医生" prop="doctor">
            <el-select v-model="baseForm.doctor" placeholder="请选择医生">
              <el-option v-for="x in doctorByDeptsOptions" :key="x.userId" :label="x.name" :value="x.userId" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否移出管理" prop="isManage">
            <el-radio-group v-model="baseForm.isManage">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </el-container>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" plain @click="handleClose">关闭</el-button>
        <el-button type="primary" size="small" @click="handleSubmit">提交</el-button>
      </span>

    </el-dialog>
  </div>
</template>
<script>

import {
  getlistEhrDepts,
  updatePatientList,
  getAreaList,
  getSysDicList,
  addIntegrateManage,
  getDoctorListQlyyDepts,
  postDoctorListQlyyDoctorsByDept,
} from "@/api/health/Patients";
import { addPatientEasyillDiabetsModel } from "@/api/health/EhrQuery";

export default {
  components: {},
  data() {
    return {
      title: "转移管理",
      open: false,
      queryParams: {},
      baseForm: {
        dept: '',
        doctor: ""
      },
      deptsOptions: [],
      doctorByDeptsOptions: [],
      sexOptions: [],
      rules: {
        dept: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        doctor: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        isManage: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      }
    }
  },
  created() {
    this.getSystemDictList('性别');
    // this.getManageHospital();
    // this.getProvinceData();
    this.getMasterData('depts');
  },
  methods: {
    async init(value) {
      this.open = true;
      this.queryParams = value;
      console.warn('transferManagementRef-value: ', value)
    },
    setDialogClosed() {
      this.open = false;
    },
    /** 获取主数据 */
    async getMasterData(field, params) {
      try {
        if (field === 'depts') {
          const res1 = await getDoctorListQlyyDepts({})
          if (res1.msg == "success") {
            this.deptsOptions = res1.data;
          }
        }
        if (field === 'doctors') {
          this.baseForm.doctor = '';
          const res2 = await postDoctorListQlyyDoctorsByDept(params)
          if (res2.msg == "success") {
            this.doctorByDeptsOptions = res2.data;
          }
        }
      } catch (err) {
        console.warn(err);
      }
    },
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sexOptions = records.filter(item => {
          return item.typeName == "性别";
        })
      }).catch(err => {
        console.log(err);
      })
    },
    handleClose() {
      this.$refs['baseFormRef'].resetFields();
      this.open = false;
    },
    handleSubmit() {
      this.$refs["baseFormRef"].validate((valid) => {
        if (valid) {
          addIntegrateManage({ idcard: this.queryParams.idcard, integrateManageStatus: this.baseForm.isManage ? "待管理" : "已管理", doctorResponseIntegrateManage: this.baseForm.doctor }).then(res => {
            if (res.msg == "success") {
              this.$message.success('提交成功');
              this.handleClose();
            }
          }).catch(err => {
            console.log(err);
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    // margin-top: 5vh !important;
  }

  .el-form .el-input {
    width: 300px !important;
  }
 .container .el-form .el-form-item__label{
    width: 150px !important;
  }
}
</style>